import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class GeomFromGeoJson extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.geomfromgeojson',
        group: 'Parsers',
        title: 'ST Geom from GeoJSON',
        description: `
      This component creates a new column with geometries created from the values
      in another column. This column should contain geometries defined in GeoJSON format.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'textcol',
          type: WorkflowComponentParamType.Column,
          title: 'Text column with geometries definition',
          parent: 'source',
          dataType: [ColumnDataType.String]
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.Postgres:
      case Provider.Redshift:
        return dedent`SELECT
                  ST_GEOMFROMGEOJSON(${params.textcol})
                  AS ${params.textcol}_geo, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Oracle:
        return dedent`SELECT
                  SDO_UTIL.FROM_JSON(${params.textcol})
                  AS "${params.textcol}_geo", t.*
                FROM ${connection.quoteName(params.source as string)} t`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.textcol}_geo`,
      type: ColumnDataType.Geometry
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.Postgres, Provider.Redshift, Provider.Oracle]
  }
}

export { GeomFromGeoJson }
